module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_5_1_drag_1.5398cb2a.png";